import { Box, Container, Paper } from "@mui/material";
import React, { useEffect } from "react";
import StepForm from "./StepForm";
import { VM_Colors } from "../Styles/VMStyles";
import StepsProvider from "../Context";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTE_HOME, SESSION_USER_ID_KEY } from "../Util/VMConstants";
import StorageFactory from "../Util/StorageFactory";
import Navbar from "../Menu/Navbar";

function Registration() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const registerPending = state?.registerPending ?? "";
  const sessionFactory = new StorageFactory('session');
  const userID = sessionFactory.get(SESSION_USER_ID_KEY);
  
  useEffect(() => {
    const storage = new StorageFactory('session');
    if (storage.has(SESSION_USER_ID_KEY)) {
      navigate('/' + ROUTE_HOME, { replace: true });
    }
  }, [navigate]);

  return (
   <Box>
      {
         userID &&<Navbar/>
      }
     <Box
      sx={{
        backgroundImage: "/static/background.jpg",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        p: 2,
        pb: 12,
        borderRadius: 3,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={4}
          sx={{
            borderRadius: 4,
            p: { xs: 3, md: 5 },
            boxShadow: `0 4px 20px ${VM_Colors.shadow || 'rgba(0,0,0,0.1)'}`,
            // if you want the Paper to be slightly translucent over the bg:
            backgroundColor: 'rgba(255,255,255,0.9)',
          }}
        >
          <StepsProvider>
            <StepForm registerPending={registerPending} />
          </StepsProvider>
        </Paper>
      </Container>
    </Box>
   </Box>
  );
}

export default Registration;
